import { HTTP } from '@/services/http'
import { Settings } from '@/settings'

export class VehicleService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

    static getPromise = {}
	static gradesPromise = null
	static tyresPromise = null
	static featuresPromise = {}

	async list() {
		return await super.get('/vehicles', { priority: true })
	}

	async get(id) {
		if (VehicleService.getPromise[id]) {
			return await VehicleService.getPromise[id]
		}

		VehicleService.getPromise[id] = super.get('/getvehicle', {
			motorvehicle_id: id,
		}).finally(() => {
			delete VehicleService.getPromise[id]
		})

		const res = await VehicleService.getPromise[id]
		return res
	}

	async tyreManufacturers() {
		if (VehicleService.tyresPromise) {
			return await VehicleService.tyresPromise
		}

		VehicleService.tyresPromise = super.get('/tyremanufacturers').finally(() => {
			VehicleService.tyresPromise = null
		})

		const res = await VehicleService.tyresPromise
		return res
	}

	async features(id) {
		if (VehicleService.featuresPromise[id]) {
			return await VehicleService.featuresPromise[id]
		}

		VehicleService.featuresPromise[id] = super.get('/features', {
			motorvehicle_id: id,
		}).finally(() => {
			delete VehicleService.featuresPromise[id]
		})

		const res = await VehicleService.featuresPromise[id]
		return res
	}

	async vrmLookup(vrm, create=false) {
		return await super.post('/vrmlookup', { vrm, create })
	}

	async vinLookup(vin, create=false) {
		return await super.post('/vrmlookup', { vin, create })
	}

	async addManual(data) {
		return await super.post('/addmanual', data)
	}

	async grades() {
		if (VehicleService.gradesPromise) {
			return await VehicleService.gradesPromise
		}

		VehicleService.gradesPromise = super.get('/grades').finally(() => {
			VehicleService.gradesPromise = null
		})

		const res = await VehicleService.gradesPromise
		return res
	}

	async bodyBuilders() {
		return await super.get('/bodybuilders')
	}

	async bodyStyles() {
		return await super.get('/bodystyles')
	}

	async cabTypes() {
		return await super.get('/cabtypes')
	}

	async classifications() {
		return await super.get('/classifications')
	}

	async upcomingAuctions() {
		return await super.get('/upcomingauction')
	}
}